// extracted by mini-css-extract-plugin
export default {"card":"styles_card__lRdLK","icon":"styles_icon__q6aEm","text":"styles_text__qJYQG","paragraph":"styles_paragraph__ersK8"};